var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPromoteYourBrandWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0v10.292l4.5-4.5 2 2.001 6.646-6.647a.5.5 0 01.765.638l-.057.07L7.5 9.207l-2-2L1 11.706V13h14v1H0V0h1z",
    fill: "#162D3D"
  })));
}

export default "data:image/svg+xml,%3csvg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M1 0V10.292L5.5 5.79289L7.5 7.793L14.1464 1.14645C14.3417 0.951184 14.6583 0.951184 14.8536 1.14645C15.0271 1.32001 15.0464 1.58944 14.9114 1.78431L14.8536 1.85355L7.5 9.20711L5.5 7.207L1 11.706V13H15V14H0V0H1Z' fill='%23162D3D'/%3e %3c/svg%3e";
export { SvgPromoteYourBrandWebsite as ReactComponent };